/**
 * USE THERAPY TIMER HOOK
 * 
 * Hook React pour s'abonner au timer global.
 * À utiliser dans TOUS les composants qui affichent le temps.
 * 
 * Aucun timer local ne doit exister dans les composants.
 */

import { useEffect, useState } from 'react';
import therapyTimer from '../services/therapyTimer';

export function useTherapyTimer() {
  const [state, setState] = useState(therapyTimer.getState());

  useEffect(() => {
    // S'abonner au timer global
    const unsubscribe = therapyTimer.subscribe(setState);
    
    // Cleanup au démontage
    return () => unsubscribe();
  }, []);

  // Retourner l'état directement (déjà formaté par le service)
  return state;
}
